import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Principals from '../components/Principals';
import PrincipalDetails from '../components/PrincipalDetails';

const PrincipalsScene = () => (
  <Routes>
    <Route index element={<Principals />} />
    <Route path="impersonation-requests" element={<Principals openImpersonationRequests />} />
    <Route path=":id/:tab?/:action?/:actionId?" element={<PrincipalDetails />} />
  </Routes>
);

export default PrincipalsScene;
